import React from 'react'
import Typography from '@mui/material/Typography'
import useFetchData from '../../../../../../hooks/useFetchData'
import SelectRatingType from '../../SelectCustom/SelectRatingType'
import { Box, Divider, Skeleton } from '@mui/material'
import { useEffect } from 'react'
import request from '../../../../../../services/request'
import ChipRating from '../Ratings/ChipRating'

const FormRatingType = ({ form = {}, errors = {}, onChange, type }) => {
  const [dataTypes, setTypes] = React.useState([])
  const [isLoadingTypes, setIsLoadingTypes] = React.useState(true)

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        setIsLoadingTypes(true)
        if (!form.ratingType) {
          setTypes([])
          return
        }
        const response = await request.get('/periodical-report/setting/rating?type=' + form.ratingType)
        setTypes(response?.data)
      } catch (error) {
        console.error('Error fetching types:', error)
      } finally {
        setIsLoadingTypes(false)
      }
    }
    fetchTypes()
  }, [form.ratingType])

  return (
    <>
      <Divider className='col-span-full' />
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Rating type
      </Typography>
      <div className='col-span-3'>
        <SelectRatingType
          onChange={(e) => onChange('ratingType', e.target.value)}
          value={form.ratingType}
          error={errors?.ratingType}
          helperText={errors?.ratingType}
          isPreview={type === 'preview'}
        />
      </div>
      <div />
      <div className='col-span-3 flex flex-col gap-1'>
        {isLoadingTypes ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Typography
              key={index}
              variant='inherit'
              className={['font-bold', index % 2 === 0 ? 'bg-loading' : ''].join(' ')}
              color='primary'
              align='right'
              component='p'
            >
              <Skeleton variant='rectangular' width='100%' height={30} />
            </Typography>
          ))
        ) : (
          <>
            {form.ratingType && dataTypes?.length > 0 ? (
              dataTypes?.map((item, index) => (
                <Box
                  key={index}
                  variant='inherit'
                  className={'px-2 py-1'}
                  color='primary'
                  component='p'
                  style={{
                    backgroundColor: index % 2 === 0 ? 'rgb(222 237 248)' : ''
                  }}
                >
                  <ChipRating key={index} {...item} />
                </Box>
              ))
            ) : (
              <Typography variant='inherit' className='opacity-75' component='p'>
                Select rating type to see the list of ratings
              </Typography>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default FormRatingType
